import React from "react";

const Image = (props) => {
  const { src, contain, cover, objectFit } = props;

  const $objectFit = objectFit
    ? objectFit
    : contain
    ? "contain"
    : cover
    ? "cover"
    : "contain";

  return (
    <img
      src={src}
      style={{
        width: "100%",
        height: "100%",
        objectFit: $objectFit,
      }}
    />
  );
};

export default Image;
